module.exports = __webpack_public_path__ + "img/20190612_132334_022.c6aed16a.jpg";